import {RPCDocs, RPCs, useRPC} from '@therms/react-modules'

export function useCurrentReportsCounts(args = {}) {
  const {call, data, isCalling} = useRPC<
    RPCDocs.Reports.GetCurrentReportCounts.v1.Args,
    RPCDocs.Reports.GetCurrentReportCounts.v1.Data
  >(RPCs.Reports.GetCurrentReportCounts.v1, args)

  let counts
  if (data) {
    counts = data.counts
  } else {
    counts = {open: 0, review: 0}
  }

  return {
    counts,
    loading: isCalling,
    refresh: call,
  }
}
